//@libs
import PropTypes from "prop-types";
//@mui-material
import HistoryIcon from "@material-ui/icons/History";
// import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
//@components
import IconButton from "./";

const ReLoadButton = ({
  title = "Asignar Equipo",
  icon = null,
  ...props
}) => {
  return (
    <IconButton
      sx={{
        "&:hover": {
          color: "#FF0000",
          transform: "scale(1.1)",
        },
      }}
      title={title}
      icon={icon || <HistoryIcon />}
      {...props}
    />
  );
};

ReLoadButton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.node,
};

export default ReLoadButton;
